// Module
var code = "<div class=\"paperbar__video\"> <video autoplay muted controls loop width=\"100%\"> <source src=\"https://user-images.githubusercontent.com/41680436/117952296-54017980-b315-11eb-8fa8-4db1b449c499.mp4\" type=\"video/mp4\"/> </video> </div> <div class=\"paperbar__works\"></div> ";
// Exports
export default code;